<template>
    <div v-if="model.pageClass == 'ALLPAGE'" class="w-full bg-white min-h-full pt-6 pb-8 md:px-8 flex justify-center">
        <ChevronDoubleLeftIcon v-if="model.list.length != 0"
            @click="sendPage(1)"
            class="h-6 w-6 place-self-center mx-1" aria-hidden="true" />
        <ChevronLeftIcon v-if="model.list.length != 0"
            @click="model.first !== null ? sendPage(model.first) : ''"
            class="h-6 w-6 place-self-center mx-1 mr-1" aria-hidden="true" />
        <ul class="flex place-items-center items-center">
            <li v-for="(page, idx) in model.list" v-bind:key="idx" 
                @click="sendPage(page)"
                :class="{ active: page === model.currentPage }"
                class="grid bg-white w-6 md:w-10 h-6 md:h-10 mr-1 text-xs md:text-sm font-medium rounded hover:bg-gray-200 focus:z-20">
                <div class="place-self-center">{{ page }}</div>
            </li>
        </ul>
        <ChevronRightIcon v-if="model.list.length != 0"
            @click="model.end !== null ? sendPage(model.end) : ''"
            class="h-6 w-6 place-self-center mx-1" aria-hidden="true" />
        <ChevronDoubleRightIcon v-if="model.list.length != 0"
            @click="sendPage(model.totalPage)"
            class="h-6 w-6 place-self-center mx-1" aria-hidden="true" />
    </div>
    <div v-else class="w-full bg-white min-h-full pt-6 pb-8 px-8 flex justify-center">
        <ChevronDoubleLeftIcon v-if="model.list.length != 0"
            @click="sendFacetPage(model.facetData, 1)"
            class="h-6 w-6 place-self-center mx-1" aria-hidden="true" />
        <ChevronLeftIcon v-if="model.list.length != 0"
            @click="model.first !== null ? sendFacetPage(model.facetData, model.first) : ''"
            class="h-6 w-6 place-self-center mx-1 mr-1" aria-hidden="true" />
        <ul class="flex place-items-center items-center">
            <li v-for="(page, idx) in model.list" v-bind:key="idx" 
                @click="sendFacetPage(model.facetData, page)"
                :class="{ active: page === model.currentPage }"
                class="grid bg-white w-6 md:w-10 h-6 md:h-10 mr-1 text-xs md:text-sm font-medium rounded hover:bg-gray-200 focus:z-20">
                <div class="place-self-center">{{ page }}</div>
            </li>
        </ul>
        <ChevronRightIcon v-if="model.list.length != 0"
            @click="model.end !== null ? sendFacetPage(model.facetData, model.end) : ''"
            class="h-6 w-6 place-self-center mx-1" aria-hidden="true" />
        <ChevronDoubleRightIcon v-if="model.list.length != 0"
            @click="sendFacetPage(model.facetData, model.totalPage)"
            class="h-6 w-6 place-self-center mx-1" aria-hidden="true" />
    </div>
</template>

<script>
import { ChevronLeftIcon, ChevronRightIcon, ChevronDoubleLeftIcon, ChevronDoubleRightIcon } from '@heroicons/vue/20/solid'

export default {
    name: "PaginationView",
    props: ["model"],
    components: {
        ChevronLeftIcon,
        ChevronRightIcon,
        ChevronDoubleLeftIcon,
        ChevronDoubleRightIcon 
    },
    methods: {
        sendPage(page) {
            // console.log("pagination에서 보낼 페이지는", page)
            this.$emit("paging", page)
            // console.log('sendPage', page)
        },
        sendFacetPage(facetData, page) {
            // console.log("pagination에서 보낼 facetData는 ", facetData)
            this.$emit("facetPaging", facetData, page)
            // console.log('sendFacetPage', facetData, page)
        }
    }
}
</script>

<style scoped>
.active {
    background-color: #e5e7eb;
    /* font-weight: bold; */
}
</style>